import { retryAfterMs } from "@slot/client-engine";

/**
 * A boot load the backend answered with an error status (decision 81). The boot retries a 5xx with its backoff and a
 * 429 after the wait the backend names (`retryAfterMs`, when the reply named one), and never another 4xx: the same
 * request would be refused the same way.
 */
export class BootHttpError extends Error {
  public constructor(
    message: string,
    public readonly status: number,
    public readonly retryAfterMs: number | null = null,
  ) {
    super(message);
    this.name = "BootHttpError";
  }

  /** The error for a non-2xx answer from `source`; a 429's wait is read from its header or its body. */
  public static async of(source: string, res: Response): Promise<BootHttpError> {
    const retryAfter = res.status === 429 ? retryAfterMs(res, await res.text().catch(() => "")) : null;
    return new BootHttpError(`${source}: request failed ${res.status} ${res.statusText}`, res.status, retryAfter);
  }
}
